import { useAnalytics } from "@/components/common/segment/AnalyticsContext";

export const useExperimentStarted = () => {
  const analytics = useAnalytics();

  const trackExperimentStarted = (
    experimentCode: string,
    variantCode: string,
    additionalData = {}
  ) => {
    // $experiment_started is a special event in segment
    // Mixpanel requires this event name. Docs here: https://docs.mixpanel.com/docs/reports/apps/experiments
    analytics?.track("$experiment_started", {
      experimentCode,
      experimentVariant: variantCode,
      ...additionalData,
    });
  };

  return { trackExperimentStarted };
};
